import React, { useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import get from 'lodash/get';
import HTMLReactParser from 'html-react-parser';

// GLOBAL FUNCTIONS
import { controlName } from 'functions';

// LOCAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

// STYLES
import styles from './reviewSpotInstructions.module.scss';

// FUNCTIONS
const filter = item => !!item.spot_instruction_id;

// RENDER
const ReviewSpotInstructionsForm = () => {
  const name = 'arySpotInstruction';
  
  // FORMIK
  const { values } = useFormikContext() || {};

  // MEMOS
  const value = useMemo(
    () => get(values, name) || [],
    [name, values]
  )
  const checkList = useMemo(
    () => value.map((item, index) => ({...item, index})).filter(filter),
    [value]
  )

  return (
    <Form.Body>
      {Array.isArray(value) && checkList.map((item, i) => (
        <Form.YesNo
          key={i}
          name={controlName('is_completed', name, item.index)}
          label={{
            prefix: `${i + 1}. `,
            label: HTMLReactParser(item.spot_instruction),
            className: styles.label,
            col: {
              className: styles.labelCol
            }
          }}
          numeric={false}
          required
        />
      ))}
    </Form.Body>
  );
}

export default function ReviewSpotInstructions(props) {
  return <Card title="Review Spot Instructions" body={<ReviewSpotInstructionsForm {...props} />} />;
}
